import { createFileRoute } from "@tanstack/react-router";

interface BaseThemeSearchParams {
  previewMapId?: string;
}

export const Route = createFileRoute("/superadmin/themes/base/$slug")({
  // Component moved to superadmin.themes.base.$slug.lazy.tsx for code splitting.
  // validateSearch must live on the non-lazy file route (createLazyFileRoute
  // only supports component/pendingComponent/errorComponent/notFoundComponent).
  validateSearch: (search: Record<string, unknown>): BaseThemeSearchParams => ({
    previewMapId: typeof search.previewMapId === "string" ? search.previewMapId : undefined,
  }),
});
